export default (theme) => ({
  card: {
    boxShadow: 'none',
    borderRadius: 20,
    background: '#FFF',

    '& .MuiCardContent-root': {
      height: '100%',
      padding: '20px 45px',
      gap: 12,
      flexDirection: 'row',
      alignItems: 'center',
      minHeight: 'auto',

      '&:last-child': {
        paddingBottom: '20px',
      },
    },
  },
  title: {
    color: '#49454F',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '27px',
    letterSpacing: '0.5px',

    [theme.breakpoints.up(768)]: {
      fontSize: 18,
    },

    [theme.breakpoints.up(1024)]: {
      fontSize: 24,
    },
  },
  content: {
    display: 'flex',
    gap: 8,
  },
});
